import {create} from 'zustand'

const useMainStore = create((set) => ({
	appTitle: 'Payd',
	resetTitle: () => set({appTitle: 'Payd.ae'}),
}))

export default useMainStore;